import React, { useEffect, useState } from "react";
import AdminPage from "./pages/index";
import "./App.css";

function App() {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    // Function to check the screen size
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768); // Adjust breakpoint for mobile size
    };

    // Initial check
    handleResize();

    // Add event listener for window resize
    window.addEventListener("resize", handleResize);

    // Cleanup event listener on component unmount
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  if (isMobile) {
    return (
      <div className="flex w-screen h-screen items-center justify-center">
        <p className="text-center text-red-500">
          ระบบปัจจุบันรองรับการทำงานบน Desktop PC เท่านั้น
        </p>
      </div>
    );
  }

  return (
    <div
      className="flex w-screen 
            h-screen flex-col justify-center 
            gap-1 items-center"
    >
      <AdminPage />
    </div>
  );
}

export default App;
